const actionTypeIdentifier = '16F6CC7B-9E61-47A8-B418-5CB4846C5667'; //this is a newid

export const getRateCard = `GET-RATE-CARD-${actionTypeIdentifier}`;
export const setRateCardError = `SET-RATE-CARD-ERROR-${actionTypeIdentifier}`;
export const setRateCardColSearchStr = `SET-RATE-CARD-COL-SEARCH-STRING-${actionTypeIdentifier}`;
export const sortRateCardItems = `SORT-RATE-CARD-${actionTypeIdentifier}`;
export const setRateCardPageSize = `SET-RATE-CARD-PAGESIZE-${actionTypeIdentifier}`;
export const setRateCardFilter = `SET-RATE-CARD-FILTER-${actionTypeIdentifier}`;
export const applyRateCardFilter = `APPLY-RATE-CARD-FILTER-${actionTypeIdentifier}`;
export const setDefaultRateCard = `SET-DEFAULT-RATE-CARD-${actionTypeIdentifier}`;